import moment from 'moment-timezone'

/**
 * Take a date string and reformat it according the current locale.
 *
 * `$formatDate('2000-01-01')` => 'Jan 01, 2000'
 */
export default ({ app }, inject) => {
  inject('formatDate', function(date, options = { emptyLabel: null, format: 'short' }) {
    if (!date && options.emptyLabel) return options.emptyLabel

    return app.i18n.d(moment(date), options.format)
  })

  /**
   * Convert a date represented by a string into a moment object.
   *
   * NOTE: We're using `moment` here, because `new Date()` will utilize timezone and
   * return a wrong date: `new Date('2000-01-01')` => Dec 31 1999 22:00:00 GMT-0200
   */
  inject('parseDate', function(date) {
    return moment(date)
  })

  inject('dob', (...args) => app.$formatDate(...args))
  inject('dobToDate', (...args) => app.$parseDate(...args))
}
